import * as Sentry from "@sentry/react";

export interface SentryConfig {
	dsn: string;
	environment: string;
	release?: string;
}

export function initSentry(config: SentryConfig) {
	if (!config.dsn) {
		console.warn("Sentry DSN not configured, error tracking disabled");
		return;
	}

	Sentry.init({
		dsn: config.dsn,
		environment: config.environment,
		release: config.release,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: config.environment === "production" ? 0.1 : 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
	});
}

export function generateTraceId(): string {
	return crypto.randomUUID();
}

export function setTraceContext(traceId: string, contentId?: string) {
	Sentry.setTag("traceId", traceId);
	if (contentId) {
		Sentry.setTag("contentId", contentId);
	}
}

export { Sentry };
